module.exports = __webpack_public_path__ + "img/Edit.9f68e596.svg";